import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';
import { generateColors } from '../../../lib/dashboard/chartConstants.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

function truncateLabel(label) {
  return label.length > 22 ? `${label.substring(0, 20)}…` : label;
}

export function BarChartBlock({ chartId, data, legendId }) {
  const colors = generateColors(data.labels.length);

  const chartData = {
    labels: data.labels,
    datasets: [{
      label: 'Jours',
      data: data.data,
      backgroundColor: colors,
      borderRadius: 3,
      borderSkipped: false
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.parsed.y.toFixed(1)} jours`
        }
      }
    },
    scales: {
      x: {
        ticks: {
          maxRotation: 45,
          minRotation: 30,
          callback(_value, index) {
            const label = data.labels[index] || '';
            return truncateLabel(label);
          }
        }
      },
      y: {
        beginAtZero: true,
        title: { display: true, text: 'Jours' }
      }
    }
  };

  return (
    <>
      <div className="legend-list" id={legendId}>
        {data.labels.map((label, idx) => (
          <span key={label} className="legend-item">
            <span className="legend-dot" style={{ background: colors[idx] }} />
            {label}{' '}
            <b style={{ marginLeft: 4, color: 'var(--text)' }}>{data.data[idx].toFixed(1)}</b>
          </span>
        ))}
      </div>
      <div className="chart-wrap" style={{ height: 420 }}>
        <Bar id={chartId} data={chartData} options={options} />
      </div>
    </>
  );
}


